import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const setAddingFavouriteStationsStatus = (
  state: StationsState,
  action: PayloadAction<StationsState['favouriteStations']['addingStatus']>
) => {
  state.favouriteStations.addingStatus = action.payload;
};
